import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { OfferPreview } from 'models/offer-preview-settings';
import { OfferBase, AnsweredRFPs } from 'models/offer.model';
import { BaseComponent } from 'shared/base/base.component';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';
import { Offer } from 'graphql/models/extended'

/**
 * Answered RFP = Answered Request For Price
 */
@Component({
  selector: 'app-answered-rfp-preview',
  templateUrl: './answered-rfp-preview.component.html',
  styleUrls: ['./answered-rfp-preview.component.scss']
})
export class AnsweredRfpPreviewComponent extends BaseComponent implements OnInit {
  offer!: OfferBase;

  answeredRFPs: AnsweredRFPs[] = [];

  pdfReady!: boolean;

  pdfSrc = '';

  activeAnsweredRFP!: AnsweredRFPs;

  isDealer = false;

  constructor(
    private offerService: OfferService,
    private storeService: StoreService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.offerService.getAnsweredRFPsForOffer(),
      this.storeService.getCurrentOffer(),
      this.storeService.isCurrentAccountDealer(),
    ])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([answeredRFPs, currentOffer, isDealer]: [AnsweredRFPs[], OfferBase, boolean]) => {
        this.answeredRFPs = answeredRFPs;
        this.isDealer = isDealer;
        const isAnsweredRFP = this.answeredRFPs.find((offer) => offer.revision === currentOffer.revision);

        if (isAnsweredRFP) {
          this.offer = {
            documentId: currentOffer.documentId,
            revision: currentOffer.revision,
            title: this.offerService.getCurrentOfferTitle(currentOffer as Offer, this.isDealer)
          };
          this.setActiveItem(isAnsweredRFP);
        } else {
          this.offer = {
            documentId: currentOffer.documentId,
            revision: this.answeredRFPs[0].revision,
            title: this.answeredRFPs[0].title
          };
          this.setActiveItem(this.answeredRFPs[0]);
        }

        this.createOfferPreview();
      });
  }

  setPdfReady(isReady: boolean): void {
    this.pdfReady = isReady;
  }

  onItemSelected(offer: AnsweredRFPs): void {
    this.setActiveItem(offer);
    this.offer.revision = offer.revision;
    this.offer.title = offer.title;
    this.pdfReady = false;

    this.pdfSrc = '';
    this.createOfferPreview();
  }

  scrollToActiveItem(): void {
    setTimeout(() => {
      const elem = document.querySelector('div.answeredRFPsPreview-item.active');

      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 0);
  }

  setActiveItem(currentOffer: AnsweredRFPs): void {
    this.activeAnsweredRFP = currentOffer;
    this.scrollToActiveItem();
  }

  createOfferPreview(): void {
    const offerDocumentId: OfferBase = { documentId: this.offer.documentId, revision: this.offer.revision };

    this.offerService.createOfferPreview(offerDocumentId, {})
      .pipe(takeUntil(this.destroyed$))
      .subscribe((offerPreview: OfferPreview) => {
        this.pdfSrc = offerPreview.url;
      });
  }
}
